import { COMMERCE } from 'self-service-api/constants/EnrolledProductLines';
import { CMS, MARKETING, OPERATIONS, SALES, SERVICE } from 'self-service-api/constants/ProductLines';
import { NavItemEnum } from '../routing/NavItems';

// @ts-expect-error svg import
import COMMERCE_HUB_ICON from 'bender-url!pricing-pages-ui-components/js/productIcon/images/CommerceHub.svg';
// @ts-expect-error svg import
import CONTENT_HUB_ICON from 'bender-url!pricing-pages-ui-components/js/productIcon/images/ContentHub.svg';
// @ts-expect-error svg import
import DATA_HUB_ICON from 'bender-url!pricing-pages-ui-components/js/productIcon/images/DataHub.svg';
// @ts-expect-error svg import
import MARKETING_HUB_ICON from 'bender-url!pricing-pages-ui-components/js/productIcon/images/MarketingHub.svg';
// @ts-expect-error svg import
import SALES_HUB_ICON from 'bender-url!pricing-pages-ui-components/js/productIcon/images/SalesHub.svg';
// @ts-expect-error svg import
import SERVICE_HUB_ICON from 'bender-url!pricing-pages-ui-components/js/productIcon/images/ServiceHub.svg';
// @ts-expect-error svg import
import SMART_CRM_ICON from 'bender-url!pricing-pages-ui-components/js/productIcon/images/SmartCrm.svg';
export const ProductIconMap = {
  [MARKETING]: MARKETING_HUB_ICON,
  [SALES]: SALES_HUB_ICON,
  [SERVICE]: SERVICE_HUB_ICON,
  [CMS]: CONTENT_HUB_ICON,
  [OPERATIONS]: DATA_HUB_ICON,
  [COMMERCE]: COMMERCE_HUB_ICON,
  [NavItemEnum.SMART_CRM]: SMART_CRM_ICON
};